import React, {Component,useEffect,useState} from 'react';
import { connect } from 'react-redux';
import classes from './PropertyManager.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import Switch from '../../components/UI/Switch/Switch';
import axios from '../../axios-local-api';
import { FaInfoCircle,FaEye,FaEyeSlash } from 'react-icons/fa';
import Collapsible from 'react-collapsible';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import Toolbar from '../../components/Toolbar/Toolbar';
import ResidentNetworks from './ResidentNetworks/ResidentNetworks';
import PspView from './PspView/PspView';
import Networks from '../../containers/Networks/Networks';
import NetworksPage from '../../components/NetworksPage/NetworksPage';
import Modal from '../../components/UI/Modal/Modal';
import Tooltip from 'react-tooltip-lite';

const ConfigureIOTSSID = (props) => {
const {
  configureFormState,
  isInvalidSSID,
  isInvalidSSIDPassword,
  handleCloseModal,
  setEnableSSIDConfigure = () => null,
  setIsInvalidSSIDPassword = () => null,
  setisInvalidSSID = () => null,
  setSsidName = () => null,
  setSsidPassword = () => null,
  setFormValue = () => null,
  onCreateIOTssidNetwork,
  selectedConfigureData
} = props;
const { ssidBroadcast, ssidName, ssidPassword, ssidEnable, showSSIDPassword } = configureFormState;
const isEditForm = selectedConfigureData && Object.keys(selectedConfigureData).length;
useEffect(() => {
  if(selectedConfigureData && Object.keys(selectedConfigureData).length) {
    setFormValue({
      configureFormState: {
        ...configureFormState,
        ssidBroadcast: selectedConfigureData.broadcast,
        ssidName: selectedConfigureData.wifiSsidName,
        ssidPassword: selectedConfigureData.wifiSsidPassphrase
      }
    })
  }
}, [selectedConfigureData])
const setShowSSIDPassword = (status) => {
  setFormValue({
    configureFormState: {
      ...configureFormState,
      showSSIDPassword: status
    }
  })
}
  const resetForm = () => {
    setIsInvalidSSIDPassword(false);
    setShowSSIDPassword(false);
    setisInvalidSSID(false);
    setSsidName('');
    setSsidPassword('');
  }
  const addSSIDFormHandler = () => {
    let info={};

     info = isEditForm ? {
      'ssid' : ssidName,
      'ssidPassword': ssidPassword,
      "enabled": ssidEnable,
      "ssidBroadcast": ssidBroadcast,
      "wifiType": "IOT",
      "method": 'patch',
      "configType": selectedConfigureData?.configType
    } : {
      'ssid' : ssidName,
      'ssidPassword': ssidPassword,
      "enabled": ssidEnable,
      "ssidBroadcast": ssidBroadcast,
      "wifiType": "IOT",
      "configType": selectedConfigureData?.configType
    }
    handleCloseModal();
    onCreateIOTssidNetwork?.(info);
    setShowSSIDPassword(false);
  }

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showTooltip , setShowToolTip] = useState(false);

  const onConfirmation = () => {
    setShowConfirmationModal(false)
    resetForm();
    setEnableSSIDConfigure(false)
    props.onDeleteSecondSsidInfoDetails();
    // setEditForm(false);
  }

  const onCancel = () => {
    handleCloseModal()
    setShowConfirmationModal(false);
  }

  const isFormDisabled = () => {
    if (isEditForm && (ssidName?.trim()?.toLowerCase() === selectedConfigureData.wifiSsidName?.trim()?.toLowerCase())
    && (ssidPassword?.trim()?.toLowerCase() === selectedConfigureData?.wifiSsidPassphrase?.trim()?.toLowerCase())
    && ssidBroadcast === selectedConfigureData.broadcast)
     {
      return true;
    }
    return (isInvalidSSID || isInvalidSSIDPassword ) ||
    (!ssidName?.length || !ssidPassword?.length) ||
    !(ssidName?.length >= 3 && ssidPassword?.length >= 8)
  }
  const confirmationModal = (
    <Modal
      show={showConfirmationModal}
    >

  </Modal>
  )
  let onOff = (<div >
    <Switch
      id="NetworkVisbilityEnableToggle"
      aria-checked={true}
      aria-label='network enable'
      onText='ON'
      offText='OFF'
      onChange={() => { setFormValue({
        configureFormState: {
          ...configureFormState,
          ssidBroadcast: !ssidBroadcast
        }
      }) }}
      checked= {ssidBroadcast}
      style={{marginTop: '10px'}}
    />
  </div>);
  return (<React.Fragment>
    <div className={classes.ConfigureIOTNetwork}>
    <div className={classes.subHeader}>
        <strong>IOT Network </strong>
      </div>
      {confirmationModal}
      <div className={classes.ConfigureSSIDBody}>
        <Box>
          <div
            id="configureSecondSSIDText"
            style={{  color: '#000', fontSize: 'small' }}
          >
             Name
          </div>
          <div id = "SecondSsidToggle" className={[classes.desktop_view, classes.switchclass].join(' ')} />
          <div
            className={classes.Input}
            style={{ padding: '2px 20px 20px 0px' }}
          >
            <input
              id="ssidNameTextbox"
              aria-label="SSID name"
              type="text"
              className={classes.InputElement}
              value={ssidName}
              placeholder='Create SSID Name'
              minLength="3"
              maxLength="32"
              max={32}
              required
              onChange={(event) => {
                const res = event.target.value.match(/^(?!.* {2})[^<>$\\`'^&;"/\n\r]+$/);
                if (!event.target.value || (res !== null && event.target.value === event.target.value.trim()))  {
                  setisInvalidSSID(false)
                }else {
                  setisInvalidSSID(true);
                }
                setFormValue({
                  configureFormState: {
                    ...configureFormState,
                    ssidName: event.target.value,
                  }
                })
              }}
            />
            <div id='SecondSSIDNameCharlen' className={classes.Helper}>3-32 characters</div>
            <div className={classes.Spacer}></div>
          </div>
          <div
            id="ssidNameErrorMsg"
            style={
              isInvalidSSID
                ? {
                  color: 'red',
                  fontSize: 12,
                  display: 'block',
                  paddingLeft: 10,
                }
                : { display: 'none' }
            }
          >
            Space is only allowed in between the characters. The following
            characters are not allowed $ {'<'} {'>'} ` \ / ^ & ; "
          </div>
        </Box>
        <Box>
          <div
            id="configureSecondSSIDPasswordText"
            style={{ color: '#000', fontSize: 'small' }}
          >
            Password
          </div>
          <div
            className={classes.Input}
            style={{ padding: '2px 20px 20px 0px' }}
          >
            <input
              id="ssidPasswordTextbox"
              aria-label="SSID password"
              type={showSSIDPassword ? "text" : "password"}
              className={classes.InputElement}
              minLength="8"
              maxLength="29"
              required
              value={ssidPassword}
              placeholder='Create New Password'
              onChange={(event) => {
                const res = event.target.value.match(/^(?!.* {2})[^<>$\\`'^&;"/\n\r]+$/);
                if (!event.target.value || (res !== null && event.target.value === event.target.value.trim())){
                  setIsInvalidSSIDPassword(false)
                }else {
                  setIsInvalidSSIDPassword(true);
                }
                setFormValue({
                  configureFormState: {
                    ...configureFormState,
                    ssidPassword: event.target.value
                  }
                })
              }}
            />
             {!showSSIDPassword ?
             <FaEyeSlash id = 'SecondSSIDEye' color="#38a9f9" size={20} style={{marginLeft: "-35px", cursor: 'pointer'}} onClick={() => { setShowSSIDPassword(true)}} /> :
            <FaEye id = 'SecondSSIDEye' color="#38a9f9" size={20} style={{marginLeft: "-35px", cursor: 'pointer'}} onClick={() => { setShowSSIDPassword(false)}} />
            }
          </div>
          <div id = 'SecondSSIDPassCharlen' className={classes.passwordHelper}>8-29 characters</div>
          <div
            id="ssidPasswordErrorMsg"
            style={
              isInvalidSSIDPassword
                ? {
                  color: 'red',
                  fontSize: 12,
                  display: 'block',
                  paddingLeft: 2,
                }
                : { display: 'none' }
            }
          >
            Space is only allowed in between the characters. The following
            characters are not allowed $ {'<'} {'>'} ` \ / ^ & ; "
          </div>
        </Box>          <Box>
            <div className={classes.BodyRow} style={{ display: 'flex' }}>
              <div
                id="secondSSIDVisibility"
                style={{


                  display: 'flex',color: '#000', fontSize: 'small'
                }}
              >
                Network Visibility
              </div>
              <div style={{ position: "relative"}}>
                <FaInfoCircle
                 id = 'SecondSSIDInfoTool' color="#38a9f9" size={15} style={{ marginLeft: '1px', marginTop: '3px' }}
                onMouseOver={() => {
                  setShowToolTip(state => !state)
                }}
                onMouseOut={() => {
                  setShowToolTip(false)
                }}
                />
                {showTooltip && <div id = 'SecondSSIDToolTipText' style={{position: "absolute", top: "-21px", left: "15px", border: "1px solid black", whiteSpace: "nowrap", padding: "0.25rem",fontSize:"12px"}}> This allows the network to be hidden or visible</div>}
              </div>

            </div>
          </Box>
          {onOff}
        <Box>
        <div className={classes.BodyRow}>
        <div className={classes.buttonContainer}>
                <button
                  disabled={
                    isFormDisabled?.()
                  }
                  id="ConfigureSSIDSaveButton"
                  className={classes.Button}
                  onClick={() => {addSSIDFormHandler()}}
                  btnType="Success"
                >
                  Save
                </button>
                <button
                id="ConfigureSSIDCancelButton"
                  className={classes.CancelButton}
                  onClick={() => {
                    setEnableSSIDConfigure();
                    setShowConfirmationModal(false);
                    handleCloseModal();
                    resetForm()
                  }
                  }
                >
                {'Cancel'}
              </button>
            </div>
          </div>
        </Box>
      </div>
    </div>
  </React.Fragment>)
}

export class PropertyManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upArrows: true,
      mUpArrow: false,
      loading: false,
      loaded: false,
      error: false,
      propertyManager: null,
      tenantDetailsLoading: false,
      tenantDetailsLoaded: false,
      tenantDetailsSuccess: false,
      tenantDetailsError: false,
      tenantDetails: null,
      tenantStats: null,
      IOTNetworkform:false,
      showIotNetwork: false,
      IotConfigureNetwork:false,
      enableSSIDConfigure: true,
      selectedTab: "product-routers",
      configureFormState: {
        ssidBroadcast: false,
        ssidName: '',
        ssidPassword: '',
        ssidEnable: true
      }
    }
  }
  onTabChange = (e) => {
    // console.log('EEEE', e)
    this.setState({ selectedTab: e.tabId });
  };
  componentDidMount() {
    this.props.onGetPropertyManagerDetails();
    this.props.onGetPropertyManagerTenantDetails();
    this.props.getIotssidNetwork("IOT");
    this.props.getNetworks();
  }

  componentDidUpdate() {
    if (this.props.tenantDetailsLoading !== this.state.tenantDetailsLoading) {
      this.setState({ tenantDetailsLoading: this.props.tenantDetailsLoading });
    }
    if (this.props.tenantDetails !== this.state.tenantDetails) {
      this.setState({ tenantDetails: this.props.tenantDetails });
    }
    if (this.props.tenantStats !== this.state.tenantStats) {
      this.setState({ tenantStats: this.props.tenantStats });
    }
    if (this.props.loading !== this.state.loading) {
      this.setState({ loading: this.props.loading });
    }
    if (this.props.propertyManager !== this.state.propertyManager) {
      this.setState({ propertyManager: this.props.propertyManager });
    }
  }

  openHandler() {
    this.setState({
      upArrows: true
    })
  }
  closeHandler() {
    this.setState({
      upArrows: false,
    })
  }

  mOpenHandler() {
    this.setState({
      mUpArrow: true
    })
  }
  mCloseHandler() {
    this.setState({
      mUpArrow: false
    })
  }
  resetUpArrows() {
    this.setState({
      upArrows: false
    })
  }





  render() {
    let residentNetworks;
    let pspView;
    let propertyInfo;
    let pspWarning;
    let SpecReadyAlert;
    // console.log(this.props, "test")

    // eslint-disable-next-line no-unused-vars
    const hasEditPermission = (sessionStorage.getItem("userRoles") || []).includes('CSSO')

    let marrow = (<Box><span style={{ color: '#0073d1', paddingTop: '6px' }}>Show</span><MdKeyboardArrowDown color={'#0073d1'} size={'30px'} /></Box>);
    if (this.state.mUpArrow) {

      marrow = (<Box><span style={{ color: '#0073d1', paddingTop: '6px' }}>Hide</span><MdKeyboardArrowUp color={'#0073d1'} size={'30px'} /></Box>);
    } else {
      marrow = (<Box><span style={{ color: '#0073d1', paddingTop: '6px' }}>Show</span><MdKeyboardArrowDown color={'#0073d1'} size={'30px'} /></Box>);
    }

    let arrow = (
      <MdKeyboardArrowDown
        color={'gray'}
        size={'30px'} />
    )

    if (this.state.upArrows) {

      arrow = (
        <MdKeyboardArrowUp
          color={'gray'}
          size={'30px'} />

      )
    } else {

      arrow = (
        <MdKeyboardArrowDown
          color={'gray'}
          size={'30px'} />

      )
    }

    if (this.state.loading) {
      propertyInfo = (
        <Spinner></Spinner>
      )
    } else if (!this.state.loading && this.state.propertyManager) {
      let residentName;
      if(this.state.propertyManager.accountType === 'COMMERCIAL'){
        residentName = this.state.propertyManager.businessName;
      }else if(this.state.propertyManager.accountType === 'RESIDENTIAL'){
        residentName = this.state.propertyManager.firstName + ' ' + this.state.propertyManager.lastName;
      }
      if(residentName === ''){
        residentName = this.state.propertyManager.businessName ? this.state.propertyManager.businessName:(this.state.propertyManager.firstName?this.state.propertyManager.firstName:'Unknown');
      }

      const resAddress = this.state.propertyManager.addressLine1 + ', ' + this.state.propertyManager.addressLine2;
      const resLocality = this.state.propertyManager.city + ', ' + this.state.propertyManager.state + ' ' + this.state.propertyManager.zipCode;
      propertyInfo = (
        <div className={classes.residentDetails}>
          <div className={[classes.residentInfo, classes.showDesktop].join(' ')}>
            <span id = 'BulkSpecTitle'className={classes.residentName}>{residentName}</span>
            <div className={classes.residentAddress}>
              <span id = 'BulkSpecAddresLabel' className={classes.resAccountAddressLabel}>{resAddress}</span>
              <span id = 'BulkSpecAddreslocality'> {resLocality}</span>
            </div>
          </div>
          <div className={[classes.residentPhone, classes.showDesktop].join(' ')}>
            <span id = 'BulkSpecphone'><label className={classes.residentPhoneLabel}>Phone : </label>{this.props.propertyManager.primaryPhone}</span>
          </div>
          <div className={classes.showMobile}>
            <Collapsible
              transitionTime={100}
              open={this.state.mUpArrow}
              onOpening={
                () => { this.mOpenHandler() }

              }
              onClosing={
                () => { this.mCloseHandler() }
              }
              trigger={
                (<Box>
                  <div>
                    <div className={classes.residentInfo} >
                      <span className={classes.residentName}>{residentName}</span>
                      <button className={classes.OpenCloseButton} style={{ float: 'right' }} aria-label="open arrow">
                        {marrow}
                      </button>

                    </div>
                  </div>
                </Box>)}>
              <div className={classes.residentInfo}>
                <div className={classes.residentAddress}>
                  <span className={classes.resAccountAddressLabel}>{resAddress}</span>
                  <span> {resLocality}</span>
                </div>
              </div>
              <div className={classes.residentPhone}>
                <span><label className={classes.residentPhoneLabel}>Phone : </label>{this.props.propertyManager.primaryPhone}</span>
              </div>
              <Box>
                <div>
                  <div className={classes.residentAccountsSection}>
                    <h3 id='SpecAccountInfoTitle'>Account Info</h3>
                  </div>
                </div>
              </Box>
              <div>
                <div className={classes.residentAccounts}>
                  <span id='SpecAccountNumberTitle' className={classes.resAccountNumLabel}>Account Number</span>
                  <span id='SpecAccountNumberNumber'>{this.props.propertyManager.accountNumber}</span>
                </div>
              </div>
            </Collapsible>
          </div>

          <div className={[classes.residentAccounts, classes.showDesktop].join(' ')}>
            <Collapsible
              transitionTime={100}
              open={this.state.upArrows}
              onOpening={
                () => { this.openHandler() }

              }
              onClosing={
                () => { this.closeHandler() }
              }
              trigger={
                (<Box>
                  <div>
                    <div className={classes.residentAccountsSection}>
                      <h3 id='SpecAccountInfoTitle'>Account Info</h3>
                      <button className={classes.OpenCloseButton} style={{ float: 'right' }} aria-label="open arrow">
                        {arrow}
                      </button>
                    </div>
                  </div>
                </Box>)}>
              <div>
                <div className={classes.residentAccounts}>
                  <span id='SpecAccountNumberTitle' className={classes.resAccountNumLabel}>Account Number</span>
                  <span id='SpecAccountNumberNumber'>{this.props.propertyManager.accountNumber}</span>
                </div>
              </div>

            </Collapsible>
          </div>


          {((this.state.tenantDetails?.isSpectrumReady === true && this.state.tenantDetails?.accountClassification !== "MDUNONBULK") || !this.state.tenantDetails?.accountClassification) && (!this.props.getIOTssidNetworkFailed || !this.state.tenantDetails?.accountClassification) && <Networks />}
          </div>
      )
    } else if (this.state.loaded && !this.state.propertyManager) {
      propertyInfo = (<div>No Property Info Available</div>)
    }

    if (this.state.tenantDetailsLoading && false) {
      residentNetworks = (<Spinner></Spinner>)
      pspView = (<Spinner></Spinner>)
    } else if (this.props.tenantDetails) {
      residentNetworks = (
        <ResidentNetworks
          getTenantData={this.props.onGetPropertyManagerTenantDetails}
          tenantStats={this.state.tenantStats}
          filter={this.props.filter}
          isLoading={this.state.tenantDetailsLoading}
          tenantDetails={this.state.tenantDetails}
        />
      )
      pspView = (
        <PspView
          tenantDetails={this.props.tenantDetails}
          getTenantData={this.props.onGetPropertyManagerTenantDetails}
          onGetTenant={this.props.onGetTenant}
          filter={this.props.filter}
          isLoading={this.state.tenantDetailsLoading}
          iotConfigured={this.props?.iotssidNetworkDetails?.wifiSsidPassphrase}
        />
      )
    } else if (this.state.tenantDetailsLoaded && !this.state.tenantDetails) {
      residentNetworks = (<div>No Tenant Info Available</div>)
      pspView = (<div></div>)
    }

    if (this.props.restoreServiceSuccess) {
      pspWarning = (
        <div
          className={classes.pspSuccessWarning}
        >
          <span>
            {'Service has been succesfully restored'}
          </span>
        </div>);
      if (!this._resetFlagsTimeout) {
        this._resetFlagsTimeout = setTimeout(() => {
          this.props.resetPropertyManagerFlags();
          this._resetFlagsTimeout = null;
        }, 5000)
      }
    }

   if (this.state.tenantDetails?.isSpectrumReady === true) {
        SpecReadyAlert =  (
            <div className={classes.SpecReadyAlertContainer}>
               <span>Spectrum Ready Services Available</span>
            </div>
        )
   }
    const isMduBulkNotReady = this.state.tenantDetails?.accountClassification === "MDUBULK" && !this.state.tenantDetails?.isSpectrumReady;
    const isClassificationNull = !this.state.tenantDetails?.accountClassification;

    this.renderTabs = () => {
      if (isMduBulkNotReady || isClassificationNull) {
        return (
          <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: '4px', padding: '24px 28px 0 28px' }}>
            <h3 style={{ margin: '0 0 0.5rem 0' }}>Resident Network</h3>
            <div style={{ display: 'flex', marginTop: '20px' }}>
              <span style={{ color: '#0073d1', fontSize: '14px', fontWeight: '600', borderBottom: '3px solid #0073d1', paddingBottom: '8px', cursor: 'pointer' }}>Network Info</span>
            </div>
          </div>
        );
      }
      return (
        <div className={classes.tabs}>
          <button
            style={this.state.selectedTab === "product-routers" ? {color:'black'} : {color:'gray'}}
            onClick={()=>this.onTabChange({tabId:'product-routers'})}
            id='product-routers'
          >
           <h3>Property Routers</h3>
          </button>
        </div>
      );
    };


    this.renderTabContent = () => {
      return (
        <div>
          {this.state.selectedTab === "product-routers" && (
            <div style={(isMduBulkNotReady || isClassificationNull) ? { display: 'flex', flexDirection: 'column', gap: '16px' } : {}}>
              {residentNetworks}
              {pspView}
            </div>
          )}
        </div>
      );
    };

    const isMduNonBulk = this.state.tenantDetails?.accountClassification === "MDUNONBULK";

    return (
      <Box>
        <Toolbar
          showLogo={true}
          isAuth={this.props.isAuthenticated}
          userId={this.props.loggedinUserId}
        />
        <div className={classes.pspPage}>
          <div className={classes.flexContainer}>
            <div className={classes.leftPanel}>
              {propertyInfo}
            </div>
            <div className={classes.rightPanel}>
              {SpecReadyAlert}
              {pspWarning}
              {isMduNonBulk ? (
                <NetworksPage isMduNonBulk={true} />
              ) : (this.state.tenantDetails?.accountClassification === "MDUBULK" && this.state.tenantDetails?.isSpectrumReady) ? (
                <NetworksPage isMduBulk={true} />
              ) : (this.props.selectedNetwork && (!this.props.getIOTssidNetworkFailed || !this.state.tenantDetails?.accountClassification)) ? (
                <NetworksPage />
              ) : (
                <>
                  {(this.state.tenantDetailsLoading || !this.state.tenantDetails) ? <Spinner /> : (
                    <div style={(isMduBulkNotReady || isClassificationNull) ? { display: 'flex', flexDirection: 'column', gap: '16px' } : {}}>
                      {this.renderTabs()}
                      {this.renderTabContent()}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </Box>
    );
  }
}



const mapStateToProps = (state => {
  return {
    propertyManager: state.propertyManager.propertyManager,
    loading: state.propertyManager.loading,
    loaded: state.propertyManager.loaded,
    error: state.propertyManager.error,
    tenantDetails: state.propertyManager.tenantDetails,
    tenantStats: state.propertyManager.tenantStats,
    tenantDetailsLoading: state.propertyManager.tenantDetailsLoading,
    tenantDetailsLoaded: state.propertyManager.tenantDetailsLoaded,
    tenantDetailsError: state.propertyManager.tenantDetailsError,
    restoreServiceSuccess: state.propertyManager.restoreServiceSuccess,
    filter: state.propertyManager.filter,
    createIOTssidNetworkSuccess: state.propertyIOTNetwork.createIOTssidNetworkSuccess,
    createIOTssidNetworkFailed: state.propertyIOTNetwork.createIOTssidNetworkFailed,
    iotssidNetworkDetails: state.propertyIOTNetwork.getIOTssidNetwork,
    getIOTssidNetworkSuccess: state.propertyIOTNetwork.getIOTssidNetworkSuccess,
    getIOTssidNetworkFailed: state.propertyIOTNetwork.getIOTssidNetworkFail,
    IOTssidNetworkFailMsg: state.propertyIOTNetwork.IOTssidNetworkFailMsg,
    selectedNetwork: state.propertyIOTNetwork.selectedNetwork,

  };
});

const mapDispatchToProps = (dispatch) => {
  return {
    onGetPropertyManagerDetails: () => dispatch(actions.getPropertyManagerDetails()),
    onGetPropertyManagerTenantDetails: (filter, search, page, size) => dispatch(actions.getPropertyManagerTenantDetails(filter, search, page, size)),
    onGetTenant: (masterAcct, tenantAcct, multi, pspPage, tenantDetails) => dispatch(actions.startAppSaga(masterAcct, tenantAcct, multi, pspPage, tenantDetails)),
    resetPropertyManagerFlags: () => dispatch(actions.resetPropertyManagerFlags()),
    onResetIOTSsidErrorSuccess: () => dispatch(actions.resetIOTSsidErrorSuccess()),
    createIOTssidNetwork: (data) => dispatch(actions.createIOTssidNetwork(data)),
    getIotssidNetwork: (wifiType) => dispatch(actions.getIOTssidNetworkDetails(wifiType)),
    getNetworks: () => dispatch(actions.getNetworks()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(PropertyManager, axios));
